import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PaymentPopupState } from './payment-popup.state';

export const selectPaymentPopupState = createFeatureSelector<PaymentPopupState>('paymentPopup');

export const selectPaymentPopupShow = createSelector(
    selectPaymentPopupState,
    (state) => state.paymentPopupShow
);
